module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-sven.d6931569.jpeg";